import { render, staticRenderFns } from "./FileDropper.vue?vue&type=template&id=169b5fac"
import script from "./FileDropper.vue?vue&type=script&lang=ts"
export * from "./FileDropper.vue?vue&type=script&lang=ts"
import style0 from "./FileDropper.vue?vue&type=style&index=0&id=169b5fac&prod&lang=styl"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports